<div [ngClass]="{ 'solid-background': useSolidBackground }" class="full-width">
  <mat-form-field appearance="outline">
    <mat-select [multiple]="useMultiSelect" [formControl]="projectPicker" placeholder="{{ placeholder || ('common.labels.projects' | translate) }}" (selectionChange)="selectProject()">
      <mat-option *ngIf="!useMultiSelect">{{ 'common.labels.all' | translate }}</mat-option>
      <mat-optgroup *ngFor="let group of groupedProjects$ | async" [label]="getGroupLabel(group)">
        <mat-option *ngFor="let project of group.projects" [value]="project._id">{{ project.label }}</mat-option>
      </mat-optgroup>
    </mat-select>
    <ng-content ngProjectAs="mat-error"/>
    <mat-error></mat-error>
  </mat-form-field>
</div>
